module.exports = __webpack_public_path__ + "static/staff-10-516731e28a876a6618d54cc19b444d5a.png";